import { useSelector } from "react-redux"
import { FilterID } from "../../../types"
import { FILTER_OPTIONS } from "../../constants"
import { useAppDispatch } from "../../hooks"
import DropdownFilter from "../dropdown-filter"
import {
  currentFilter,
  setConversationsFilter
} from "../../../redux/slices/conversations"

const ConversationFilter = () => {
  const dispatch = useAppDispatch()
  const currentConversationFilter = useSelector(currentFilter)

  const handleFilterChange = (value: FilterID) => {
    dispatch(setConversationsFilter(value))
  }

  return (
    <DropdownFilter<FilterID>
      value={currentConversationFilter}
      onChange={handleFilterChange}
      options={FILTER_OPTIONS}
    />
  )
}

export default ConversationFilter
